// eslint-disable-next-line @typescript-eslint/no-require-imports
const jssConfig = require('./src/temp/config');
// eslint-disable-next-line @typescript-eslint/no-require-imports
const plugins = require('./src/temp/next-config-plugins') || {};

const publicUrl = jssConfig.publicUrl;

/**
 * @type {import('next').NextConfig}
 */
const nextConfig = {
  // Needed only if the static JS and CSS files are served from a CDN.
  // See: https://nextjs.org/docs/pages/api-reference/config/next-config-js/assetPrefix
  // Set assetPrefix to our public URL
  // assetPrefix: publicUrl,

  // Allow specifying a distinct distDir when concurrently running app in a container
  distDir: process.env.NEXTJS_DIST_DIR || '.next',

  // Make the same PUBLIC_URL available as an environment variable on the client bundle
  env: {
    PUBLIC_URL: publicUrl,
  },

  i18n: {
    // These are all the locales you want to support in your application.
    // These should generally match (or at least be a subset of) those in Sitecore.
    locales: [
      'default',
      'en',
      'en-gb',
      'en-us',
      'en-ch',
      'en-lu',
      'en-nl',
      'en-ca',
      'en-au',
      'en-hk',
      'en-jp',
      'en-kr',
      'en-my',
      'en-nz',
      'en-sg',
      'en-th',
      'en-dk',
      'en-fi',
      'en-se',
      'en-is',
      'en-ie',
      'en-mt',
      'en-za',
      'en-ae',
      'en-no',
      'fr-be',
      'fr-ch',
      'fr-fr',
      'nl-be',
      'nl-nl',
      'pt-pt',
      'pt-br',
      'es-es',
      'de-ch',
      'de-at',
      'de-de',
      'de-li',
      'it-it',
      'zh-cn',
      'zh-hk',
      'ja-jp',
      'ko-kr',
      'th-th',
    ],
    // This is the locale that will be used when visiting a non-locale
    // prefixed path e.g. `/styleguide`.
    defaultLocale: 'default',
    localeDetection: false,
  },

  // Enable React Strict Mode
  reactStrictMode: true,

  // Disable the X-Powered-By header. Follows security best practices.
  poweredByHeader: false,

  // use this configuration to ensure that only images from the whitelisted domains
  // can be served from the Next.js Image Optimization API
  // see https://nextjs.org/docs/app/api-reference/components/image#remotepatterns
  images: {
    dangerouslyAllowSVG: true,
    remotePatterns: [
      {
        protocol: 'https',
        hostname: 'edge*.**',
        port: '',
      },
      {
        protocol: 'https',
        hostname: 'xmc-*.**',
        port: '',
      },
      {
        protocol: 'https',
        hostname: 'feaas*.blob.core.windows.net',
        port: '',
      },
      {
        protocol: 'https',
        hostname: 'tst-cdn.abrdn.com',
        port: '',
      },
      {
        protocol: 'https',
        hostname: 'picsum.photos',
        port: '',
      },
      {
        protocol: 'https',
        hostname: '*.vercel.app',
      },
    ],
  },

  async rewrites() {
    // When in connected mode we want to proxy Sitecore paths off to Sitecore
    return [
      // API endpoints
      {
        source: '/sitecore/api/:path*',
        destination: `${jssConfig.sitecoreApiHost}/sitecore/api/:path*`,
      },
      // media items
      {
        source: '/-/:path*',
        destination: `${jssConfig.sitecoreApiHost}/-/:path*`,
      },
      // healthz check
      {
        source: '/healthz',
        destination: '/api/healthz',
      },
      // rewrite for Sitecore service pages
      {
        source: '/sitecore/service/:path*',
        destination: `${jssConfig.sitecoreApiHost}/sitecore/service/:path*`,
      },
      {
        source: '/resources/:path*',
        destination: `/api/resources/:path*`,
      },
      {
        source: '/docs:path*',
        destination: `/api/docs:path*`,
      },
      {
        source: '/library/:path*',
        destination: `/api/library/:path*`,
      },
    ];
  },
  typescript: {
    // Disable type checking until Typescript errors are fixed.
    ignoreBuildErrors: true,
  },
  productionBrowserSourceMaps: true,
};

module.exports = () => {
  // Run the base config through any configured plugins
  return Object.values(plugins).reduce((acc, plugin) => plugin(acc), nextConfig);
};
